export const BUYER_ROLES = new Set(["buyer"]);
export const SELLER_ROLES = new Set(["seller"]);
export const NEGOTIATOR_ROLES = new Set(["negotiator"]);

export function isBuyerRole(role: string | null | undefined): boolean {
  return !!role && BUYER_ROLES.has(role);
}

export function isSellerRole(role: string | null | undefined): boolean {
  return !!role && SELLER_ROLES.has(role);
}

export function isNegotiatorRole(role: string | null | undefined): boolean {
  return !!role && NEGOTIATOR_ROLES.has(role);
}

/**
 * The account type in the words people signed up with (signup.tsx, AuthModal.tsx), never the raw
 * `profiles.role` value: an account that chose "Rights Holder" is not shown "seller". A Map, so a
 * value that happens to be an Object.prototype key ("constructor", "toString") has no label.
 */
const ACCOUNT_TYPE_LABELS: ReadonlyMap<string, string> = new Map([
  ["buyer", "Licensee"],
  ["seller", "Rights Holder"],
  ["negotiator", "Rights Negotiator"],
  ["admin", "Admin"],
]);

/** The friendly name of an account type, or null for none or one this app does not know. */
export function accountTypeLabel(role: string | null | undefined): string | null {
  return (role && ACCOUNT_TYPE_LABELS.get(role)) || null;
}

/** The org position (`profiles.org_role`, L3) in words. A Map for the same reason as above. */
const ORG_ROLE_LABELS: ReadonlyMap<string, string> = new Map([
  ["owner", "Owner"],
  ["admin", "Admin"],
  ["editor", "Editor"],
  ["member", "Member"],
  ["viewer", "Viewer"],
  ["billing", "Billing"],
]);

/** The friendly name of an org position, or null for none or one this app does not know. */
export function orgRoleLabel(orgRole: string | null | undefined): string | null {
  return (orgRole && ORG_ROLE_LABELS.get(orgRole)) || null;
}
